// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__26MJl","inputWrap":"Table_inputWrap__3NcjR","col":"Table_col__3Xqns","bmiTooltip":"Table_bmiTooltip__1_4hU"};